import { createUseStyles } from 'react-jss';
import { ActionPalette, GrayscalePalette } from '@tcl-boron-colors/colors';
import { Classes } from 'jss';

export const defaultCommonToggleInputOverrideClasses = {
  disabled: '',
  icon: '',
  input: '',
  label: '',
};

export const useCommonToggleInputStyles: (
  data?: {
    isSelected: boolean;
    disabled: boolean;
  } & {
    theme?: Jss.Theme;
  },
) => Classes<'label' | 'disabled' | 'icon' | 'input'> = createUseStyles({
  label: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    margin: '5px 0',
  },
  disabled: {
    color: GrayscalePalette[400],
    pointerEvents: 'none',
  },
  icon: {
    color: ({ isSelected, disabled }: { isSelected: boolean; disabled: boolean }) =>
      isSelected ? (disabled ? GrayscalePalette[400] : ActionPalette[600]) : GrayscalePalette[500],
    marginRight: '10px',
  },
  input: {
    appearance: 'none',
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) ': {
      opacity: '0',
      width: '0px',
      height: '0px',
    },
  },
});

export const useCommonToggleInputGroupStyles = createUseStyles({
  root: {
    margin: '20px 0',
  },
});
